import React, {useState} from 'react';
import {ConfigApi, OrderType} from "../../../../../services/Api/types";
import {useTranslation} from "react-i18next";
import {ReactComponent as BarcodeIco} from "../../../../../../images/icons/barcode.svg";
import CartChangeOrderDetailsScanModal from "../CartChangeOrderDetailsScanModal";

interface Props {
    room: string | undefined;
    setRoom: React.Dispatch<React.SetStateAction<string | undefined>>
    currentType: OrderType | "";
    config: ConfigApi | undefined;
}

const CartChangeOrderDetailsRoomModal = ({room, setRoom, currentType, config}: Props) => {
    const {t} = useTranslation();
    const possibilityToEdit = config?.ordering.number_editable;
    const possibilityToScan = !config?.ordering.scanner_disabled
    const [showScannerModal, setShowScannerModal] = useState(false);

    if (currentType !== OrderType.ROOM_SERVICE) return <></>;

    return (
        <div className="mt-4 d-flex flex-column room-section">
            <h1 className="h5 mb-3">{t("modules.cart.field.room.title")}</h1>
            <div className="d-flex align-items-center justify-content-between gap-2">
                <div className="form-group mb-0 w-100">
                    <input disabled={!possibilityToEdit} type="text" value={room}
                           onChange={(event) => setRoom(event.target.value)}
                           className="form-control"
                           id="room"
                           placeholder={t("modules.room_number_modal.field.room_number.title") + " *"}/>
                    <label htmlFor="room">{t("modules.room_number_modal.field.room_number.title") + " *"}</label>
                </div>
                {
                    possibilityToScan && (
                        <button onClick={() => setShowScannerModal(true)}
                                className="btn btn-default align-self-stretch"
                                aria-label={t("modules.cart.field.scan_room_qr_code.title")}>
                            <BarcodeIco aria-hidden="true"/>
                        </button>
                    )
                }
                {
                    showScannerModal &&
                    <CartChangeOrderDetailsScanModal show={showScannerModal} type={OrderType.ROOM_SERVICE}
                                                     handleSave={setRoom} config={config} currentType={currentType}
                                                     onHide={() => setShowScannerModal(false)}/>
                }
            </div>
        </div>
    )
}

export default CartChangeOrderDetailsRoomModal;